<template>
  <div
    v-if="isYiban"
    :class="{ 'draw-button': true, 'draw-button-transition': !moveStatus }"
    :style="{ top: top + 'px', left: left + 'px',  width: drawButtonWidth + 'px',  height: drawButtonWidth + 'px', }"
    ref="drawButton"
    @touchstart="touchMousedown"
    @touchmove.stop.prevent="touchMousemove"
    @touchend="touchMouseup"
    @click="touchClick"
  >
    <!-- <i :class="icon"></i> -->
    <span v-html="icon"></span>
  </div>
</template>
<script>
/**
    pc端只需要把事件替换成这样的事件即可
    @mousedown="touchMousedown"
    @mousemove.stop.prevent="touchMousemove"
    @mouseup="touchMouseup"
 */
export default {
  props: {
    icon: {
      type: String,
      default: '返回<br/>易伴'
    }
  },
  data () {
    return {
      top: 0,
      left: 0,
      startTop: 0,
      startLeft: 0,
      etop: 0,
      eleft: 0,
      width: 0,
      height: 0,
      boxwidth: 0,
      boxheight: 0,
      padding: 10,
      moveStatus: false,
      isYiban: false,
      drawButtonWidth: 45 // 按钮的宽高
    }
  },
  created () {
    this.width = window.document.documentElement.clientWidth
    this.height = window.document.documentElement.clientHeight
    this.left = this.width - this.padding - this.drawButtonWidth
    this.top = this.height - this.padding - 80 - 50
    this.boxwidth = this.drawButtonWidth
    this.boxheight = this.drawButtonWidth
  },
  mounted () {
    try {
      if (localStorage.getItem('isForm') == 1) {
        this.isYiban = true
      }
    } catch (error) {}
  },
  methods: {
    touchMousedown (e) {
      this.moveStatus = true
      this.startTop = this.$refs.drawButton.offsetTop
      this.startLeft = this.$refs.drawButton.offsetLeft
      this.etop = e.pageY
      this.eleft = e.pageX
    },
    touchMousemove (e) {
      if (!this.moveStatus) return
      this.top = e.pageY - this.etop + this.startTop
      this.left = e.pageX - this.eleft + this.startLeft
    },
    touchMouseup (e) {
      this.moveStatus = false
      if (this.left > this.width / 2) {
        this.left = this.width - this.padding - this.boxwidth
      } else {
        this.left = 0 + this.padding
      }
      if (this.top < 0) {
        this.top = 0 + this.padding
      }
      if (this.top + this.boxheight > this.height) {
        this.top = this.height - this.padding - this.boxheight
      }
    },
    touchClick () {
      // alert('点击了')
      window.location.href = 'http://f.yiban.cn/iapp373804'
      this.$emit('touchClick', 1)
    }
  }
}
</script>
<style lang="scss">
.draw-button {
  font-size: 12px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  border-radius: 50%;
  position: fixed;
  background: #fff;
  box-shadow: 1px 1px 10px rgb(145, 145, 145);
  z-index: 999;
  line-height: 14px;
}
.draw-button-transition {
  transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/DrawButton.vue